import { render, staticRenderFns } from "./EmployeeAttendanceEdit.vue?vue&type=template&id=52736538&scoped=true&"
import script from "./EmployeeAttendanceEdit.vue?vue&type=script&lang=js&"
export * from "./EmployeeAttendanceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52736538",
  null
  
)

export default component.exports